import Box from "@material-ui/core/Box";
import { FC, SetStateAction, useState } from "react";
import CustomSelect from "../../Ui/CustomSelect";
import FileUploadLinkcy from "../FileUpload/FileUploadLinkcy";
import { useToastNotifications } from "../../../utils/toastUtils";
import { FileInterfaceLinkcy } from "../../../interface/FileInterface";
import { fileToBase64 } from "../../../utils/fileUtils";
import { DocumentTypeInfo } from "../../../graphql/onboarding/document/types/DocumentTypeInfo";
import { CreateUserInput } from "../../../types/graphql-global-types-onboarding";
import { DocumentsType_documentsType } from "../../../graphql/onboarding/document/types/DocumentsType";
import { DocumentType } from "../../../enums/document";

interface DocumentUserProps {
  disable?: boolean;
  isSubmitted?: boolean;
  setInformation(info: SetStateAction<CreateUserInput>): void;
  information: CreateUserInput;
  documentsType: (DocumentsType_documentsType | null)[];
}
const DocumentUser: FC<DocumentUserProps> = (props) => {
  const { information, disable, setInformation, documentsType } = props;

  const { showErrorToast } = useToastNotifications();
  const isSubmitted = props.isSubmitted ? props.isSubmitted : false;
  const identidyDoc = documentsType?.filter(
    (d) =>
      d?.type === DocumentType.IDENTITY_CARD ||
      d?.type === DocumentType.DRIVING_LICENCE ||
      d?.type === DocumentType.PASSPORT,
  );
  const [category, setCategory] = useState<DocumentTypeInfo | null>(
    identidyDoc?.[0] || null,
  );

  const proofDoc = documentsType?.find(
    (d) => d?.type === DocumentType.PROOF_OF_ADDRESS,
  );

  const identidyDocOption = identidyDoc.map((i) => ({
    id: i?.id || "",
    label: i?.name || "",
  }));

  const handleUpload = async (
    documentType: DocumentTypeInfo | null | undefined,
    filesArg: (FileInterfaceLinkcy | undefined)[] | undefined,
    type: "IDENTITY" | "ADDRESS",
  ) => {
    if (!documentType || !filesArg?.length) return;

    const prepared = await Promise.all(
      filesArg
        .filter((f): f is FileInterfaceLinkcy => Boolean(f)) // ⬅️ vire les undefined
        .map(async (f) => {
          // si déjà en base64 (ex : document rechargé), on réutilise
          let base64 = f.base64Content;
          if (!base64 && f.file) {
            base64 = await fileToBase64(f.file as unknown as File);
          }
          if (!base64) return null; // rien à ajouter

          return {
            type: documentType.type,
            base64Content: base64,
            filename: f?.filename ?? (f as any)?.file?.name ?? "file",
            fileType: f?.filetype ?? (f as any)?.file?.type ?? "",
          };
        }),
    );

    const newDocuments = prepared.filter(Boolean) as NonNullable<
      (typeof prepared)[number]
    >[];
    if (!newDocuments.length) return;

    setInformation((prev) => ({
      ...prev,
      documents: [
        ...(prev.documents ?? []).filter((doc) => {
          if (!doc) return false;
          return type === "IDENTITY"
            ? ![
                DocumentType.IDENTITY_CARD,
                DocumentType.DRIVING_LICENCE,
                DocumentType.PASSPORT,
              ].includes(doc.type as any)
            : doc.type !== DocumentType.PROOF_OF_ADDRESS;
        }),
        ...newDocuments,
      ],
    }));
  };

  const handleRemoveFile = (type: string) => {
    setInformation((prevInfo) => {
      return {
        ...prevInfo,
        documents: [
          ...prevInfo?.documents?.filter((doc) => doc && doc?.type !== type)!,
        ],
      };
    });
  };

  const handleSelect = (name: string, value: string) => {
    const docType = documentsType?.find((d) => d?.id === value);
    if (docType) setCategory(docType);
  };

  return (
    <Box>
      <CustomSelect
        setValue={handleSelect}
        options={identidyDocOption}
        value={category?.id}
        disabled={disable}
        isSubmitted={isSubmitted}
      />
      <FileUploadLinkcy
        key={category?.id}
        category={category?.type || ""}
        label={"Pièce d'identité"}
        setDocument={(files) =>
          category && handleUpload(category, files, "IDENTITY")
        }
        isSubmitted={isSubmitted}
        fileMultiple={
          information?.documents?.filter(
            (doc) =>
              !!doc &&
              [
                DocumentType.IDENTITY_CARD,
                DocumentType.DRIVING_LICENCE,
                DocumentType.PASSPORT,
              ].includes(doc.type as any),
          ) as unknown as FileInterfaceLinkcy[] | undefined
        }
        onRemove={handleRemoveFile}
        multiple
        disabled={!category?.id}
      />
      <FileUploadLinkcy
        key={proofDoc?.id}
        category={proofDoc?.type || ""}
        label={"Justificatif d'addresse"}
        setDocument={(files) =>
          proofDoc && handleUpload(proofDoc, files, "ADDRESS")
        }
        isSubmitted={isSubmitted}
        fileData={
          information?.documents?.find(
            (doc) => doc?.type === proofDoc?.type,
          ) as unknown as undefined
        }
        onRemove={handleRemoveFile}
      />
    </Box>
  );
};
export default DocumentUser;
